import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import achievementsEn from './locales/en/achievements.json';
import analyticsEn from './locales/en/analytics.json';
import audioRecorderEn from './locales/en/audioRecorder.json';
import authEn from './locales/en/auth.json';
import breatheEn from './locales/en/breathe.json';
import commonEn from './locales/en/common.json';
import componentsEn from './locales/en/components.json';
import cookiesEn from './locales/en/cookies.json';
import difficultyEn from './locales/en/difficulty.json';
import errorsEn from './locales/en/errors.json';
import feedbackEn from './locales/en/feedback.json';
import flowEn from './locales/en/flow.json';
import headerEn from './locales/en/header.json';
import landingEn from './locales/en/landing.json';
import landingResultEn from './locales/en/landingResult.json';
import landingTestEn from './locales/en/landingTest.json';
import layoutEn from './locales/en/layout.json';
import messagesEn from './locales/en/messages.json';
import navigationEn from './locales/en/navigation.json';
import notificationsEn from './locales/en/notifications.json';
import partOfSpeechEn from './locales/en/partOfSpeech.json';
import profileEn from './locales/en/profile.json';
import resultEn from './locales/en/result.json';
import sessionEn from './locales/en/session.json';
import speakingEn from './locales/en/speaking.json';
import studentEn from './locales/en/student.json';
import studentReadingEn from './locales/en/studentReading.json';
import studentWritingEn from './locales/en/studentWriting.json';
import validationEn from './locales/en/validation.json';
import vocabularyEn from './locales/en/vocabulary.json';
import dashboardEn from './locales/en/dashboard.json';
import listeningEn from './locales/en/listening.json';
import listeningVi from './locales/vi/listening.json';
import grammarEn from './locales/en/grammar.json';
import grammarVi from './locales/vi/grammar.json';
import surveyVi from './locales/vi/survey.json';

import achievementsVi from './locales/vi/achievements.json';
import analyticsVi from './locales/vi/analytics.json';
import audioRecorderVi from './locales/vi/audioRecorder.json';
import authVi from './locales/vi/auth.json';
import breatheVi from './locales/vi/breathe.json';
import commonVi from './locales/vi/common.json';
import componentsVi from './locales/vi/components.json';
import cookiesVi from './locales/vi/cookies.json';
import difficultyVi from './locales/vi/difficulty.json';
import errorsVi from './locales/vi/errors.json';
import feedbackVi from './locales/vi/feedback.json';
import flowVi from './locales/vi/flow.json';
import headerVi from './locales/vi/header.json';
import landingVi from './locales/vi/landing.json';
import landingResultVi from './locales/vi/landingResult.json';
import landingTestVi from './locales/vi/landingTest.json';
import layoutVi from './locales/vi/layout.json';
import messagesVi from './locales/vi/messages.json';
import navigationVi from './locales/vi/navigation.json';
import notificationsVi from './locales/vi/notifications.json';
import partOfSpeechVi from './locales/vi/partOfSpeech.json';
import profileVi from './locales/vi/profile.json';
import resultVi from './locales/vi/result.json';
import sessionVi from './locales/vi/session.json';
import speakingVi from './locales/vi/speaking.json';
import studentVi from './locales/vi/student.json';
import studentReadingVi from './locales/vi/studentReading.json';
import studentWritingVi from './locales/vi/studentWriting.json';
import validationVi from './locales/vi/validation.json';
import vocabularyVi from './locales/vi/vocabulary.json';
import dashboardVi from './locales/vi/dashboard.json';
import studentLearningEn from './locales/en/studentLearning.json';
import studentLearningVi from './locales/vi/studentLearning.json';
import lessonsEn from './locales/en/lessons.json';
import lessonsVi from './locales/vi/lessons.json';
import assessmentEn from './locales/en/assessment.json';
import assessmentVi from './locales/vi/assessment.json';
import avatarEn from './locales/en/avatar.json';
import avatarVi from './locales/vi/avatar.json';
import conversationEn from './locales/en/conversation.json';
import conversationVi from './locales/vi/conversation.json';
import surveyEn from './locales/en/survey.json';
import defaultEn from './locales/en/default.json';
import defaultVi from './locales/vi/default.json';

const resources = {
    en: {
        dashboard: dashboardEn,
        achievements: achievementsEn,
        analytics: analyticsEn,
        audioRecorder: audioRecorderEn,
        auth: authEn,
        breathe: breatheEn,
        common: {
            ...commonEn,
            ...defaultEn
        },
        components: componentsEn,
        cookies: cookiesEn,
        difficulty: difficultyEn,
        errors: errorsEn,
        feedback: feedbackEn,
        flow: flowEn,
        header: headerEn,
        landing: landingEn,
        landingResult: landingResultEn,
        landingTest: landingTestEn,
        layout: layoutEn,
        messages: messagesEn,
        navigation: navigationEn,
        notifications: notificationsEn,
        partOfSpeech: partOfSpeechEn,
        profile: profileEn,
        result: resultEn,
        session: sessionEn,
        speaking: speakingEn,
        student: studentEn,
        studentLearning: studentLearningEn,
        studentReading: studentReadingEn,
        studentWriting: studentWritingEn,
        validation: validationEn,
        vocabulary: vocabularyEn,
        listening: listeningEn,
        grammar: grammarEn,
        lessons: lessonsEn,
        assessment: assessmentEn,
        avatar: avatarEn,
        conversation: conversationEn,
        survey: surveyEn
    },
    vi: {
        dashboard: dashboardVi,
        achievements: achievementsVi,
        analytics: analyticsVi,
        audioRecorder: audioRecorderVi,
        auth: authVi,
        breathe: breatheVi,
        common: {
            ...commonVi,
            ...defaultVi
        },
        components: componentsVi,
        cookies: cookiesVi,
        difficulty: difficultyVi,
        errors: errorsVi,
        feedback: feedbackVi,
        flow: flowVi,
        header: headerVi,
        landing: landingVi,
        landingResult: landingResultVi,
        landingTest: landingTestVi,
        layout: layoutVi,
        messages: messagesVi,
        navigation: navigationVi,
        notifications: notificationsVi,
        partOfSpeech: partOfSpeechVi,
        profile: profileVi,
        result: resultVi,
        session: sessionVi,
        speaking: speakingVi,
        student: studentVi,
        studentLearning: studentLearningVi,
        studentReading: studentReadingVi,
        studentWriting: studentWritingVi,
        validation: validationVi,
        vocabulary: vocabularyVi,
        listening: listeningVi,
        grammar: grammarVi,
        lessons: lessonsVi,
        assessment: assessmentVi,
        avatar: avatarVi,
        conversation: conversationVi,
        survey: surveyVi
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        nsSeparator: '.',
        ns: Object.keys(resources.en),
        defaultNS: false,
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false,
        },

        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        },
        react: {
            useSuspense: false
        }
    });

export default i18n;
